import { useState } from "react";

const CollegeStudentManagement = () => {
  const [search, setSearch] = useState("");
  const [students, setStudents] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(100);

  const handleSearch = () => {
    console.log("Search:", search);
    // Fetch students here
  };

  const resetFilters = () => {
    setSearch("");
  };

  return (
    <div className="container-fluid ">
      <h5 className="fw-bold mb-3" style={{borderBottom:'2px solid #90b732', color:'#90b732', paddingBottom:'8px', fontSize:'16px'}}>College Student Management</h5>

      {/* Info Bar */}
      <div className="alert alert-light text-success py-2" style={{fontSize:'14px'}}>
        Students registered till 16-09-2018 appear here. For students registered after that, please go to{" "}
        <a href="#">Students-&gt;Student List</a>
      </div>

      {/* Toolbar */}
      <div className="d-flex align-items-center mb-2 border bg-light py-2"style={{fontSize:'13px'}}>
        <button className="btn btn-light me-2 " style={{fontSize:'13px'}}>
          <i className="bi bi-funnel-fill text-dark fs-6"></i> <span className="text-primary fw-bold">Filters / Options</span>
        </button>
        <button className="btn btn-light me-2"style={{fontSize:'12px',marginLeft:'420px'}}>
          <i className="bi bi-file-earmark-excel"></i>
        </button>
        <button className="btn btn-light me-2"style={{fontSize:'12px'}}>
          <i className="bi bi-gear-fill"></i>
        </button>
        <input
          type="text"
          className="form-control me-2"
          style={{ width: "300px", fontSize:'12px' }}
          placeholder="Course or Student Name or College"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="btn btn-primary" style={{fontSize:'13px'}} onClick={handleSearch} >
          <i className="bi bi-search"></i>
        </button>
      </div>

      {/* Pagination & Action Buttons */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <button className="btn btn-light btn-sm me-1">&lt;&lt;</button>
          <button className="btn btn-light btn-sm me-1">&lt;</button>
          Page:
          <input
            type="number"
            className="form-control d-inline-block mx-1"
            style={{ width: "50px" }}
            value={pageNum}
            onChange={(e) => setPageNum(e.target.value)}
          />
          of 1
          <button className="btn btn-light btn-sm ms-1">&gt;</button>
          <button className="btn btn-light btn-sm ms-1">&gt;&gt;</button>
          Page Size:
          <input
            type="number"
            className="form-control d-inline-block mx-1"
            style={{ width: "60px" }}
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
          />
        </div>

        <div>
          <button className="btn btn-secondary btn-sm me-1">Assign Test</button>
          <button className="btn btn-secondary btn-sm me-1">Reschedule Test</button>
          <button className="btn btn-secondary btn-sm me-1">Mark Attendance</button>
          <button className="btn btn-secondary btn-sm">Link to Batch</button>
        </div>
      </div>

      {/* Student Table */}
      <table className="table table-striped table-bordered">
        <thead style={{background:'#90b732', color:'#fff'}}>
          <tr>
            <th scope="col">
              <input type="checkbox" />
            </th>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">College Name</th>
            <th scope="col">Certificate</th>
            <th scope="col">Batch</th>
            <th scope="col">Program Start Date</th>
            <th scope="col">Program End Date</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          {students.length === 0 ? (
            <tr>
              <td colSpan="9" className="text-center">
                No Students Found
              </td>
            </tr>
          ) : (
            students.map((stu, idx) => (
              <tr key={idx}>
                <td>
                  <input type="checkbox" />
                </td>
                <td>{idx + 1}</td>
                <td>{stu.name}</td>
                <td>{stu.college}</td>
                <td>{stu.certificate}</td>
                <td>{stu.batch}</td>
                <td>{stu.startDate}</td>
                <td>{stu.endDate}</td>
                <td>{stu.status}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CollegeStudentManagement;
